import { Dialog } from 'quasar';

import DialogConfirm from '@/components/dialog/dialog-confirm.vue';
import { ICONS_NAME } from '@/constants/ui/icons.constants';
import { i18nService } from '@/services/i18n-service';
import { store } from '@/store';
import { APPLICATION_MODULE } from '@/store/application-module';
import { ALLOW_NAVIGATION } from '@/store/application-module/actions';
import { GET_ALLOW_NAVIGATION } from '@/store/application-module/getters';

async function getNavigationConfirmDialog(): Promise<boolean> {
    return new Promise((resolve) => {
        Dialog.create({
            component: DialogConfirm,
            componentProps: {
                title: i18nService.t('ACTIONS.LEAVE.TITLE'),
                formWidth: '500',
                confirmLabel: i18nService.t('ACTION.CONFIRM'),
                messageKey: 'ACTIONS.LEAVE.CONFIRM',
                iconName: ICONS_NAME.DANGER_SOLID,
                message: i18nService.t('UNSAVED_CHANGES')
            }
        })
            .onOk(() => {
                void store.dispatch(`${APPLICATION_MODULE}/${ALLOW_NAVIGATION}`, {});
                resolve(true);
            })
            .onCancel(() => {
                resolve(false);
            });
    });
}

export function usePreventNavigationHelper(): {
    confirmNavigation: () => Promise<boolean>;
} {
    const confirmNavigation = async (): Promise<boolean> => {
        if (!store.getters[`${APPLICATION_MODULE}/${GET_ALLOW_NAVIGATION}`]) {
            return getNavigationConfirmDialog();
        } else {
            return Promise.resolve(true);
        }
    };

    return { confirmNavigation };
}
